var React = require('react');

function MapPinSimpleInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.0781 30.1641C10.6055 30.9844 11.8359 30.9844 12.3633 30.1641C20.918 17.8594 22.5 16.5703 22.5 12C22.5 5.78906 17.4609 0.75 11.25 0.75C4.98047 0.75 0 5.78906 0 12C0 16.5703 1.52344 17.8594 10.0781 30.1641ZM11.25 16.6875C8.61328 16.6875 6.5625 14.6367 6.5625 12C6.5625 9.42188 8.61328 7.3125 11.25 7.3125C13.8281 7.3125 15.9375 9.42188 15.9375 12C15.9375 14.6367 13.8281 16.6875 11.25 16.6875Z","fill":"white"}));
}

MapPinSimpleInline.defaultProps = {"width":"23","height":"31","viewBox":"0 0 23 31","fill":"none"};

module.exports = MapPinSimpleInline;

MapPinSimpleInline.default = MapPinSimpleInline;
